import { render } from "./AdminTexts.vue?vue&type=template&id=3885335d&scoped=true&bindings={\"lan\":\"data\",\"languages\":\"data\",\"texts\":\"data\",\"filterStr\":\"data\",\"getTexts\":\"options\",\"openEditText\":\"options\",\"showText\":\"options\",\"htmlToPlainText\":\"options\"}"
import script from "./AdminTexts.vue?vue&type=script&lang=js"
export * from "./AdminTexts.vue?vue&type=script&lang=js"

import "./AdminTexts.vue?vue&type=style&index=0&id=3885335d&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3885335d"

export default script